import {fetchBaseQuery} from '@reduxjs/toolkit/query';
import {createApi} from '@reduxjs/toolkit/query/react';

import {
  AddrDetailApiArg,
  AddrDetailApiResponse,
  AddrSuggestionsApiArg,
  AddrSuggestionsApiResponse,
} from '../types/api/api';

export const addressApi = createApi({
  baseQuery: fetchBaseQuery({baseUrl: process.env.METADA_URL}),
  reducerPath: 'address',
  endpoints: (build) => ({
    addrDetail: build.query<AddrDetailApiResponse, AddrDetailApiArg>({
      query: (queryArg) => ({
        url: `address/v1/detail/${queryArg.placeId}`,
        params: {language: queryArg.language},
      }),
    }),
    addrSuggestions: build.query<AddrSuggestionsApiResponse, AddrSuggestionsApiArg>({
      query: (queryArg) => ({
        url: `address/v1/suggestions`,
        params: {term: queryArg.term, country: queryArg.country, language: queryArg.language},
      }),
    }),
  }),
});

export const {useAddrSuggestionsQuery, useLazyAddrDetailQuery} = addressApi;
